import type { BlogArticle } from './blog-data'
import { normalizeTagToSlug } from './blog-tags'

/** Posts shown before the "Show more" control. The rest stay in the server HTML. */
export const GUIDES_VISIBLE = 12
export const SPOTLIGHTS_VISIBLE = 6

export const MODEL_CHIPS = [
  { slug: 'model-3', label: 'Model 3' },
  { slug: 'model-y', label: 'Model Y' },
  { slug: 'model-s', label: 'Model S' },
  { slug: 'model-x', label: 'Model X' },
  { slug: 'cybertruck', label: 'Cybertruck' },
] as const

export type ModelSlug = (typeof MODEL_CHIPS)[number]['slug']

export function parseModelParam(value: string | undefined): ModelSlug | undefined {
  return MODEL_CHIPS.find((chip) => chip.slug === value)?.slug
}

export function hasModelTag(article: BlogArticle, model: ModelSlug): boolean {
  return article.tags.some((tag) => normalizeTagToSlug(tag) === model)
}

export function modelCounts(articles: BlogArticle[]): Record<ModelSlug, number> {
  return Object.fromEntries(
    MODEL_CHIPS.map(({ slug }) => [slug, articles.filter((a) => hasModelTag(a, slug)).length]),
  ) as Record<ModelSlug, number>
}

export function newestFirst(articles: BlogArticle[]): BlogArticle[] {
  return articles.toSorted(
    (a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime(),
  )
}

/** Guides and sound spotlights are different jobs: how-to vs. a themed sound list. */
export function splitSpotlights(articles: BlogArticle[]): {
  guides: BlogArticle[]
  spotlights: BlogArticle[]
} {
  return {
    guides: articles.filter((a) => a.category !== 'sound-spotlights'),
    spotlights: articles.filter((a) => a.category === 'sound-spotlights'),
  }
}
